/**
 * Variáveis de ambiente do sistema com defaults seguros.
 * Acessar sempre por aqui (não direto via import.meta.env) pra ter um único ponto de fallback.
 */
export const APP_NAME = import.meta.env.VITE_APP_NAME || 'Touch the Trophy';
export const APP_URL = import.meta.env.VITE_APP_URL || 'http://localhost:5174';
export const LANDING_URL = import.meta.env.VITE_LANDING_URL || 'http://localhost:5173';
export const DEMO_MODE = (import.meta.env.VITE_DEMO_MODE || 'true') === 'true';
export const OTP_EXAMPLE = import.meta.env.VITE_OTP_EXAMPLE || '000000';
export const PIX_TIMER_SECONDS = Number(import.meta.env.VITE_PIX_TIMER_SECONDS || '480');
export const REGISTRATION_PRICE = Number(import.meta.env.VITE_REGISTRATION_PRICE || '29.90');
export const VERIFICATION_EXPLORER_URL =
  import.meta.env.VITE_VERIFICATION_EXPLORER_URL || 'https://testnet.bscscan.com/tx/';
export const BLOCKCHAIN_PROOF_URL =
  import.meta.env.VITE_BLOCKCHAIN_PROOF_URL ||
  'https://etherscan.io/nft/0x4e502ab1bb313b3c1311eb0d11b31a6b62988b86/4995';

// Métodos de pagamento (modo demonstração)
export const POINTS_BALANCE = Number(import.meta.env.VITE_POINTS_BALANCE || '12450');
export const POINTS_COST = Number(import.meta.env.VITE_POINTS_COST || '2990');
export const MILES_COST = Number(import.meta.env.VITE_MILES_COST || '1200');
export const CRYPTO_COST_ETH = Number(import.meta.env.VITE_CRYPTO_COST_ETH || '0.005');
export const CRYPTO_COST_USDC = Number(import.meta.env.VITE_CRYPTO_COST_USDC || '30');
